import { colors } from '@peachjar/components';
import { css } from 'emotion';
import * as React from 'react';
import sadTurtleSVG from '../assets/sad_turtle.svg';

const ErrorBoundaryPage: React.FC = () => {
  return (
    <>
      <div className={cn.content}>
        <div>
          <img src={sadTurtleSVG} width="541" height="455" />
          <p className={cn.text}>Uh oh! We seem to have stumbled...</p>
          <p className={cn.description}>
            Refresh the page now or try again later.
          </p>
        </div>
      </div>
    </>
  );
};

export default ErrorBoundaryPage;

const cn = {
  brandbar: css`
    z-index: 50;
  `,
  content: css`
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    text-align: center;
    padding-top: 50px;
    overflow: auto;
    height: 100vh;
    overflow-y: scroll;
  `,
  text: css`
    font-size: 25px;
    font-weight: bold;
    line-height: 32px;
    color: ${colors.prussian};
    padding-top: 40px;
    margin-bottom: 8px;
  `,
  description: css`
    font-size: 16px;
    line-height: 24px;
    color: ${colors.prussian};
  `,
  boxErrorWrapper: css`
    display: flex;
    justify-content: center;
    margin-bottom: 80px;
    font-size: 10px;
    padding-top: 30px;
    color: #707070;
    & p {
      margin: 0px;
    }
  `,
  boxError: css`
    margin-top: 20px;
    padding-bottom: 100px;
    width: 80%;
    padding: 16px;
    text-align: left;
    background-color: #f5f5f5;
    border-radius: 5px;
  `,
};
